import { is } from 'immutable';
import { createSelectorCreator, defaultMemoize } from 'reselect';

const createImmutableSelector = createSelectorCreator(
  defaultMemoize,
  is
);

const authSelector = (state: any) => state.get('auth');
const authTokenSelector = createImmutableSelector([authSelector], auth => {
  return auth.get('token') || localStorage.getItem('token');
});

export {
  authSelector,
  authTokenSelector,
};
